window.addEventListener("load", () => {
  handleCustomLenghtVariant();
  handleProductSort();

  const shippingAdressApartement = document.querySelector('.grfq-form-group:has(label[for="shipping_address[address2]"])');
  if (shippingAdressApartement) shippingAdressApartement.remove();

  const cartItemImage = document.querySelectorAll(".cartitem__img-container img");
  for (let image of cartItemImage) {
    if (image.src == "https://ambis-solutions-ag.myshopify.com/pages/undefined") image.src = "https://ambis-solutions-ag.myshopify.com/cdn/shop/t/3/assets/placeholder.svg?v=60171537716238525791758789497"
  }

})

document.addEventListener('DOMContentLoaded', () => {
  // Initial + kurzer Nachlauf, falls die App async rendert
  updateQuoteBadgeSafe();
  /* setTimeout(updateQuoteBadgeSafe, 150); */
  
  // Delegiert: Mengen-Änderungen
  document.addEventListener('change', (e) => {
    if (e.target.matches('.grfq-item-quantity-input')) {
      setTimeout(updateQuoteBadgeSafe, 500);
    }
  });

  // Delegiert: Löschen/Hinzufügen-Buttons etc.
  document.addEventListener('click', (e) => {
    if (e.target.closest('.grfq-variant-quantity-icon, .product-form__quote, .grfq-item-quantity-button')) {
      setTimeout(updateQuoteBadgeSafe, 500);
    }
  });
});

/* ---------- Helpers ---------- */

/* const debouncedUpdate = debounce(updateQuoteBadgeSafe, 100); */

function updateQuoteBadgeSafe() {

  const headerIcon = document.querySelector('.quotify-sticky-cart-btn');
  if (!headerIcon) return; // keine Ziel-UI vorhanden → sauber raus
  
  let badge = headerIcon.querySelector('.rfq-badge');
  if (!badge) {
    badge = document.createElement('span');
    headerIcon.appendChild(badge);
  }
  
  const total = getAmountOfQuotesSafe();
    badge.textContent = String(total);
  
}

function getAmountOfQuotesSafe() {
  let sum = 0;
    for (const k of Object.keys(localStorage)) {
      if (/samitaRFQ\/group_\d+\.item_\d+$/i.test(k)) {
        const raw = localStorage.getItem(k);
        if (!raw) continue;
        let obj;
        try {
          obj = JSON.parse(raw);
        } catch {
          continue; // fehlerhaften Eintrag ignorieren
        }
        const q = Number(obj?.qty);
        if (Number.isFinite(q) && q > 0) sum += q;
      }
    }
  return sum;
}

// kleines, konfliktarmes Debounce
/* function debounce(fn, delay = 100) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(null, args), delay);
  };
} */


const observer = new MutationObserver(() => {
    const requestQuotePage = document.querySelectorAll("#grfq-form");
    for(let quotes of requestQuotePage) {
        const elements = quotes.querySelectorAll("p, label, a, strong, small, th, button, div, h1, h2, h3, h4, input, textarea, .multiselect__placeholder, .grfq-collapsible-title, .grfq-button-text, .grfq-control-label");
        if (elements.length > 0) {
            handleTranslations(elements);
        }
    }
});

observer.observe(document.body, { childList: true, subtree: true });




function handleTranslations(elements) {
  const lang = document.documentElement.lang || "en";
  for (let el of elements) {
      for (let key in translations) {
        if(el.tagName == "INPUT") {
            if (key == el.placeholder) {
                el.placeholder = translations[key][lang];
            }
        } else {
            for (let node of el.childNodes) {
                if (node.nodeType === Node.TEXT_NODE) {
                    const text = node.textContent.trim();
                    if (text === key) {
                        // Ersetze nur den Textanteil, lasse HTML-Kinder wie <span> bestehen
                        
                        node.textContent = translations[key][lang];
                    }
                }
            }
        }
    }
  }
}



function handleCustomLenghtVariant() {
  const customLenghtVariant = document.querySelector(".custom-length-variant > div input");
  if(customLenghtVariant) {

    customLenghtVariant.addEventListener("input", () => {
      const variantValue = Number(customLenghtVariant.value);
      const maxLength = Number(document.querySelector(".max-zuschnitt small").textContent);
      
      customLenghtVariant.setAttribute("max", maxLength)
      
      if (variantValue > maxLength - 1) {
        customLenghtVariant.value = maxLength - 1;
        
        // wichtig: Plugin informieren
        customLenghtVariant.dispatchEvent(new Event("input", { bubbles: true }));
        customLenghtVariant.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
    customLenghtVariant.addEventListener("change", () => {
      const variantValue = Number(customLenghtVariant.value);
      const minLength = 10;
      
      if (variantValue < minLength) {
        customLenghtVariant.value = minLength;
        
        // wichtig: Plugin informieren
        customLenghtVariant.dispatchEvent(new Event("input", { bubbles: true }));
        customLenghtVariant.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

}

function handleProductSort() {
  const sortBy = document.getElementById("SortBy");
  if(sortBy) {
    sortBy.querySelector("[value=best-selling]").remove()
    sortBy.querySelector("[value=price-ascending]").remove()
    sortBy.querySelector("[value=price-descending]").remove()
    sortBy.querySelector("[value=created-ascending]").remove()
    sortBy.querySelector("[value=created-descending]").remove()
  }
}





let translations = {
  "Contact information": {
    de: "Kontakt Information",
    en: "Contact information",
  },
  "Contact Information": {
    de: "Kontakt Information",
    en: "Contact Information",
  },
  "Email address": {
    de: "E-Mail",
    en: "Email address",
  },
  "Products": {
    de: "Produkte",
    en: "Products",
  },
  "Product": {
    de: "Produkt",
    en: "Product",
  },
  "Quantity": {
    de: "Menge",
    en: "Quantity",
  },
  "submit quote": {
    de: "Anfrage absenden",
    en: "submit quote",
  },
  "add Quote": {
    de: "zur Anfrage hinzufügen",
    en: "add Quote",
  },
  "continue shopping": {
    de: "zurück zum Shop",
    en: "continue shopping",
  },
  "Heim": {
    de: "Startseite",
    en: "home",
  },
  "Enter your email": {
    de: "E-Mail Adresse eingeben",
    en: "Enter your email",
  },
  "Search to add product": {
    de: "Suchen um ein Produkt hinzuzufügen",
    en: "Search to add product",
  },
  "Login to auto-fill your registered information": {
    de: "Melden Sie sich an, um Ihre registrierten Daten automatisch auszufüllen.",
    en: "Login to auto-fill your registered information",
  },
  "First name": {
    de: "Vorname",
    en: "First name",
  },
  "Last name": {
    de: "Nachname",
    en: "Last name",
  },
  "Phone number": {
    de: "Telefon",
    en: "Phone number",
  },
  "Enter your phone number": {
    de: "Geben Sie Ihre Telefonnummer ein",
    en: "Enter your phone number",
  },
  "Enter your first name": {
    de: "Geben Sie Ihren Vornamen ein",
    en: "Enter your first name",
  },
  "Enter your last name": {
    de: "Geben Sie Ihren Nachnamen ein",
    en: "Enter your last name",
  },
  "Shipping address": {
    de: "Versandadresse",
    en: "Shipping address",
  },
  "Country/region": {
    de: "Land/Region",
    en: "Country/region",
  },
  "Company/attention": {
    de: "Firma",
    en: "Company/attention",
  },
  "Enter your company/attention": {
    de: "Geben Sie den Namen Ihrer Firma an",
    en: "Enter your company/attention",
  },
  "Address": {
        de: "Adresse",
        en: "Address",
    },
    "Enter your address": {
        de: "Geben Sie Ihre Adresse an",
        en: "Enter your address",
    },
    "City": {
        de: "Ort",
        en: "City",
    },
    "Enter your city": {
        de: "Geben Sie Ihre Ortschaft an",
        en: "Enter your city",
    },
    "State": {
    de: "Kanton/Bundesland",
    en: "State",
  },
  "Postal code": {
    de: "PLZ",
    en: "Postal Code",
  },
  "Enter your postal code": {
    de: "Geben Sie ihre Postleitzahl an",
    en: "Enter your postal code",
  },
  "Request Submitted": {
    de: "Anfrage abgesendet",
    en: "Request Submitted",
  },
  "Thank you for submitting a quote request!": {
    de: "Vielen Dank für Ihre Angebotsanfrage!",
    en: "Thank you for submitting a quote request!",
  },
  "Continue Shopping": {
    de: "zurück zum Shop",
    en: "Continue Shopping",
  },
};